import { render, staticRenderFns } from "./ArticleCitationsModal.vue?vue&type=template&id=738ee66e&scoped=true"
import script from "./ArticleCitationsModal.vue?vue&type=script&lang=js"
export * from "./ArticleCitationsModal.vue?vue&type=script&lang=js"
import style0 from "./ArticleCitationsModal.vue?vue&type=style&index=0&id=738ee66e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738ee66e",
  null
  
)

export default component.exports